export const RPC = "https://polygon-mainnet.infura.io/v3/e64420cd0419491e8b7f695547ab2e88"
export const CHAIN_ID = 137